<template>
    <div>
        <div>
            <fieldset>
                <div class="row">
                    <legend>Wearer Information</legend>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-2 "> Name:</div>
                    <div class="columns small-8 medium-10"> {{sampleobject.firstName}} {{sampleobject.lastName}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-2 "> Practice: </div>
                    <div class="columns small-8 medium-10"> {{sampleobject.practiceName}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4  medium-2 "> Role: </div>
                    <div class="columns small-8 medium-10"> {{sampleobject.role}}</div>
                </div>
            </div>
            <div class="column small-12 medium-12">
                <div class="row">
                    <div class="columns small-4 medium-2"> Current Lens: </div>
                    <div class="columns small-8 medium-10"> {{sampleobject.currentLens}} </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: ["sampleobject"]
};
</script>
<style>
.frame-review-section {
  margin-top: 15px;
}
</style>
